import Styles from './style.module.scss'

export default function TableEmptyHandler({
  title = 'Empty',
  desription = 'There is no data available at the moment'
}) {

  return (
    <div className={Styles.container}>
      <h3>{title}</h3>
      <span>{desription}</span>
    </div>
  )
}